import React from 'react';
import PropTypes from 'prop-types';
import Ranking, { DISPLAY_SIMPLE } from 'components/Ranking';

const DEFAULT_LIMIT = 10;

function LeaderboardSummary({ tournament, limit = DEFAULT_LIMIT }) {
  const rankings =
    tournament && tournament.leaderBoard && tournament.leaderBoard.rankings;
  if (!rankings || rankings.length === 0) {
    return null;
  }
  const places =
    tournament &&
    tournament.winningPlaces &&
    tournament.winningPlaces.winningPlaces &&
    tournament.winningPlaces.winningPlaces.map(p => p.place);

  return (
    <div className="tournament-list-group-leaderboard rankings">
      {rankings.slice(0, limit).map((element, idx) => (
        <Ranking
          key={idx}
          places={places}
          {...element}
          display={DISPLAY_SIMPLE}
        />
      ))}
    </div>
  );
}

LeaderboardSummary.propTypes = {
  rankings: PropTypes.arrayOf(PropTypes.object),
  limit: PropTypes.number
};

export default LeaderboardSummary;
